import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#4C6985",
		d: "M8 15.976A7.975 7.975 0 1 0 8 .026a7.975 7.975 0 0 0 0 15.95Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M7.94 3.568a4.184 4.184 0 0 0-3.47 6.52l-.618 2.308 2.657-.713a4.184 4.184 0 1 0 1.432-8.115ZM5.989 8.593a.65.65 0 1 1 0-1.298.65.65 0 0 1 0 1.298Zm1.962 0a.65.65 0 1 1 0-1.298.65.65 0 0 1 0 1.298Zm1.96 0a.649.649 0 1 1 0-1.297.649.649 0 0 1 0 1.297Z"
	})]
});
const ForwardRef = forwardRef(SvgChatmin);
export { ForwardRef as ReactComponent };
